import React from 'react';
import { Helmet } from "react-helmet";
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Layout, Button, Breadcrumb } from 'antd'

import AdminHeader from '../../components/AdminHeader/AdminHeader';
import Footer from '../../components/Footer/Footer';

import isAuthenticated from '../../utils/isAuthenticated';
import { logout } from "../../reducers/user/actions";
import { getRoleReadPermission, getSiteReadPermission, getUserReadPermission, getConsentReadPermission, getGeneralSettingsReadPermission } from "../../reducers/user/selectors";

import classes from './AdminSettings.css';

const routes = require('../../routes.json');

const { Content } = Layout;


class AdminSettings extends React.Component {
  render() {

    const { siteReadPermission, roleReadPermission, userReadPermission, consentReadPermission, generalSettingsReadPermission } = this.props;

    return (
      <div style={{ backgroundColor: '#FAFAFA' }}>
        <Helmet>
          <title>Trial Management Portal: Settings</title>
        </Helmet>
        <Layout className={classes.parentContainer}>
          <AdminHeader />
          <Content className={classes.content}>
            <h3 className="headline-default">Admin Settings</h3>

            <Breadcrumb>
              <Breadcrumb.Item>Admin Settings</Breadcrumb.Item>
            </Breadcrumb>

            <div className={classes.buttons}>
              {siteReadPermission && <Link to={routes.admin.settingsSites}><Button type='primary' size='large'>Site management</Button></Link>}
              {roleReadPermission && <Link to={routes.admin.settingsRoles}><Button type='primary' size='large'>Role management</Button></Link>}
              {userReadPermission && <Link to={routes.admin.settingsUsers}><Button type='primary' size='large'>User management</Button></Link>}
              {userReadPermission && <Link to={routes.admin.settingsUsersBulk}><Button type='primary' size='large'>Bulk User management</Button></Link>}
              {consentReadPermission && <Link to={routes.admin.consentEditor}><Button type='primary' size='large'>Consent management</Button></Link>}
              {generalSettingsReadPermission && <Link to={routes.admin.settingsGeneral}><Button type='primary' size='large'>General Settings</Button></Link>}
            </div>
          </Content>
          <Footer noAdminLink />
        </Layout>
      </div>
    );
    }
}

const mapStateToProps = (state) => ({
  siteReadPermission: getSiteReadPermission(state),
  roleReadPermission: getRoleReadPermission(state),
  userReadPermission: getUserReadPermission(state),
  consentReadPermission: getConsentReadPermission(state),
  generalSettingsReadPermission: getGeneralSettingsReadPermission(state),
});

const mapDispatchToProps = { logout };

export default isAuthenticated(connect(mapStateToProps, mapDispatchToProps)(AdminSettings));



// WEBPACK FOOTER //
// ./src/containers/AdminSettings/AdminSettings.js